import { WindowPercentageArea } from '@customer-apps/shared/enums';
import { EnumDictionary } from '@customer-apps/shared/utils';

export const windowPercentageAreaDictionary: EnumDictionary<WindowPercentageArea, number> = {
    [WindowPercentageArea.Small]: 0.1,
    [WindowPercentageArea.Medium]: 0.25,
    [WindowPercentageArea.Large]: 0.35
};
